module.exports = __webpack_public_path__ + "img/door.e40c2095.png";